import React from 'react';
import PropTypes from 'prop-types';

const EditText = ({
  placeholder = '',
  value = '',
  onChange,
  type = 'text',
  disabled = false,
  fullWidth = true,
  className = '',
  ...props
}) => {
  const baseClasses =
    'tw-border tw-border-[#e1e3ea] tw-rounded-lg tw-bg-global-8 tw-text-edittext-1 tw-transition-colors tw-duration-200 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-blue-500';

  const inputClasses = `
    ${baseClasses}
    ${fullWidth ? 'tw-w-full' : ''}
    ${disabled ? 'tw-cursor-not-allowed tw-opacity-50 tw-bg-gray-100' : ''}
    tw-px-3 tw-py-2.5 tw-text-sm sm:tw-text-base
    ${className}
  `
    .trim()
    .replace(/\s+/g, ' ');

  return (
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={inputClasses}
      {...props}
    />
  );
};

EditText.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
};

export default EditText;
